import { render, staticRenderFns } from "./SerraMappaView.vue?vue&type=template&id=a170dfec&scoped=true&"
import script from "./SerraMappaView.vue?vue&type=script&lang=js&"
export * from "./SerraMappaView.vue?vue&type=script&lang=js&"
import style0 from "./SerraMappaView.vue?vue&type=style&index=0&id=a170dfec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a170dfec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
